(function () {
  if (typeof window === 'undefined') return;

  function setup(section) {
    var toggle = section.querySelector('[data-mm-video-toggle]');
    var media = section.querySelector('.mm-video__media');
    if (!toggle || !media) return;

    var videos = Array.prototype.slice.call(section.querySelectorAll('.mm-video__player'));
    if (!videos.length) return;

    // Whether the button is force-shown on top of a playing video (tap-to-reveal).
    var revealed = false;

    function visibleVideos() {
      // Only the video shown at the current breakpoint should play, to avoid two audio tracks at once.
      return videos.filter(function (video) {
        return video.offsetParent !== null;
      });
    }

    function isPlaying() {
      return visibleVideos().some(function (video) {
        return !video.paused && !video.ended;
      });
    }

    // La section est loin sous la ligne de flottaison : aucune vidéo n'est téléchargée tant que le
    // visiteur n'en approche pas, puis seule celle du bon écran reçoit son src.
    var near = false;

    function load(video) {
      if (video.dataset.mmLoaded) return;
      video.dataset.mmLoaded = '1';
      Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
        source.src = source.dataset.src;
      });
      video.preload = 'auto';
      video.load();
    }

    function startVisibleVideos() {
      if (!near) return;
      visibleVideos().forEach(function (video) {
        load(video);
        video.muted = true;
        video.play().catch(function () {});
      });
    }

    function render() {
      var playing = isPlaying();
      toggle.classList.toggle('is-paused', !playing);
      toggle.classList.toggle('is-hidden', playing && !revealed);
      toggle.setAttribute('aria-pressed', String(playing));
      toggle.setAttribute(
        'aria-label',
        playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel
      );
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      var playing = isPlaying();
      videos.forEach(function (video) {
        if (video.offsetParent === null) {
          video.pause();
          return;
        }
        if (playing) {
          video.pause();
        } else {
          load(video);
          video.play().catch(function () {});
        }
      });
      revealed = false;
      render();
    });

    // Tapping the video while it plays and the button is hidden brings the button back.
    media.addEventListener('click', function () {
      if (!isPlaying()) return;
      revealed = !revealed;
      render();
    });

    videos.forEach(function (video) {
      video.addEventListener('play', render);
      video.addEventListener('pause', render);
      video.addEventListener('loadedmetadata', startVisibleVideos);
    });

    render();

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        near = true;
        startVisibleVideos();
      }, { rootMargin: '300px 0px' });
      observer.observe(section);
    } else {
      near = true;
      startVisibleVideos();
    }

    window.addEventListener('resize', startVisibleVideos);
  }

  function init() {
    var sections = document.querySelectorAll('.mm-video');
    sections.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
